import { render } from "./SyllabusEventDetailsPage.vue?vue&type=template&id=120c64fd&ts=true"
import script from "./SyllabusEventDetailsPage.vue?vue&type=script&lang=ts"
export * from "./SyllabusEventDetailsPage.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/src/services/admin/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__